import moment from 'moment';

const isDate = (date) => {
  let isdate = false;
  if (isNaN(date) && typeof date !== 'object' && moment(date, [moment.ISO_8601], true).isValid()) {
    isdate = true;
  }
  if (/^[0-9][0-9]:[0-9][0-9]$/.test(date)) {
    isdate = true;
  }
  if (/^(((19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])) [0-9][0-9]:[0-9][0-9])$/.test(date)) {
    isdate = true;
  }
  if (date instanceof Date) {
    isdate = true;
  }
  return isdate;
}

export { isDate };